"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./index.scss");
const cloud_rain_svg_1 = __importDefault(require("./assets/icons/cloud-rain.svg"));
const cloud_snow_svg_1 = __importDefault(require("./assets/icons/cloud-snow.svg"));
const pause_svg_1 = __importDefault(require("./assets/icons/pause.svg"));
const sun_svg_1 = __importDefault(require("./assets/icons/sun.svg"));
const rainy_bg_webp_1 = __importDefault(require("./assets/rainy-bg.webp"));
const summer_bg_webp_1 = __importDefault(require("./assets/summer-bg.webp"));
const winter_bg_webp_1 = __importDefault(require("./assets/winter-bg.webp"));
const summer_mp3_1 = __importDefault(require("./assets/sounds/summer.mp3"));
const rain_mp3_1 = __importDefault(require("./assets/sounds/rain.mp3"));
const winter_mp3_1 = __importDefault(require("./assets/sounds/winter.mp3"));
var Seasons;
(function (Seasons) {
    Seasons["SUMMER"] = "summer";
    Seasons["RAIN"] = "rain";
    Seasons["WINTER"] = "winter";
})(Seasons || (Seasons = {}));
const pageEls = {
    icon: {
        '1': document.querySelector('.btn__icon_1'),
        '2': document.querySelector('.btn__icon_2'),
        '3': document.querySelector('.btn__icon_3')
    },
    btn: {
        '1': document.querySelector('.btn_1'),
        '2': document.querySelector('.btn_2'),
        '3': document.querySelector('.btn_3')
    },
    bg: document.querySelector('.bg-img'),
    volumeController: document.querySelector('.volume-controller')
};
const seasonNum = {
    '1': Seasons.SUMMER,
    '2': Seasons.RAIN,
    '3': Seasons.WINTER
};
const weather = {
    [Seasons.SUMMER]: {
        audio: new Audio(summer_mp3_1.default),
        icon: sun_svg_1.default,
        bg: summer_bg_webp_1.default,
        str: '1'
    },
    [Seasons.RAIN]: {
        audio: new Audio(rain_mp3_1.default),
        icon: cloud_rain_svg_1.default,
        bg: rainy_bg_webp_1.default,
        str: '2'
    },
    [Seasons.WINTER]: {
        audio: new Audio(winter_mp3_1.default),
        icon: cloud_snow_svg_1.default,
        bg: winter_bg_webp_1.default,
        str: '3'
    }
};
const setBaseIcons = () => {
    for (const key in seasonNum) {
        const season = seasonNum[key];
        if (pageEls.icon[key]) {
            const iconElement = pageEls.icon[key];
            if (iconElement) {
                iconElement.src = weather[season].icon;
            }
        }
    }
};
const changeTheWeather = (clickedWeather) => {
    if (pageEls.bg) {
        pageEls.bg.src = weather[clickedWeather].bg;
        const iconElement = pageEls.icon[weather[clickedWeather].str];
        if (iconElement) {
            for (const season in Seasons) {
                const audio = weather[Seasons[season]].audio;
                if (audio) {
                    if (clickedWeather !== Seasons[season] && !audio.paused) {
                        audio.pause();
                        setBaseIcons();
                    }
                }
            }
            const audio = weather[clickedWeather].audio;
            if (audio) {
                if (audio.paused) {
                    audio.play().then(function () {
                        iconElement.src = pause_svg_1.default;
                    });
                }
                else {
                    audio.pause();
                    iconElement.src = weather[clickedWeather].icon;
                }
            }
        }
    }
};
setBaseIcons();
if (pageEls.bg) {
    pageEls.bg.src = summer_bg_webp_1.default;
}
if (pageEls.volumeController) {
    const volController = pageEls.volumeController;
    pageEls.volumeController.addEventListener('input', () => {
        for (const season in Seasons) {
            const audio = weather[Seasons[season]].audio;
            if (audio) {
                audio.volume = volController.valueAsNumber;
            }
        }
    });
}
Object.keys(pageEls.btn).forEach((key) => {
    const btn = pageEls.btn[key];
    if (btn) {
        btn.addEventListener('click', () => {
            switch (key) {
                case '1':
                    changeTheWeather(Seasons.SUMMER);
                    break;
                case '2':
                    changeTheWeather(Seasons.RAIN);
                    break;
                case '3':
                    changeTheWeather(Seasons.WINTER);
                    break;
                default:
                    changeTheWeather(Seasons.SUMMER);
            }
        });
    }
});
